import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { Text } from '@beef/ui-kit';

import styles from './styles.pcss';

const HEADER = '1';

const cx = classNames.bind({ ...styles });

export const PersonalData = ({ userLicense }) => (
  <ul className={cx('list')}>
    {userLicense.map((license) => {
      if (license.number === HEADER) {
        return (
          <li key={license.head}>
            <Text size="size2-m">{`${license.head} ${license.text}`}</Text>
          </li>
        );
      }

      return (
        <li key={license.head}>
          <Text size="size5-r-l">
            <b className={cx('head')}>{license.head}</b>
            {license.text}
          </Text>
        </li>
      );
    })}
  </ul>
);

PersonalData.propTypes = {
  userLicense: PropTypes.array,
};
